import api from './api.js'

// const addClientEndpoint = "api/clients/";
// const updateClientEndpoint = "api/clients/";
// const getClientsEndpoint = "api/clients/?nutritionist=";
// const addClientNoteEndpoint = "api/clientnotes/";

const addClientEndpoint = "api/nutritionists/clients";
const updateClientEndpoint = "api/nutritionists/clients/";
const getClientsEndpoint = "api/nutritionists/clients/";
const addClientNoteEndpoint = "api/nutritionists/clientnotes";
const getCommissionsEndpoint = "api/get-commision/";
const postSendEmailsEndpoint = "api/nutritionists/send-emails";
const getNotificationsEndpoint = "api/nutritionists/get-notifications";
const readNotificationsEndpoint = "api/nutritionists/read-notifications";
const clearNotificationsEndpoint = "api/nutritionists/remove-notifications";

export default {
  setAxios(){
    api.setAxios();
  },
  addClient(body){
    return api.post(addClientEndpoint,body);
  },
  updateClient(id,body){
    return api.put(updateClientEndpoint+id,body);
  },
  getClients(nutId){
    return api.get( getClientsEndpoint+`${nutId}`);
  },
  addClientNote(body){
    return api.post(addClientNoteEndpoint,body);
  },
  getCommissions(nutId){
    return api.get( getCommissionsEndpoint+`${nutId}`);
  },
  getNotifications(created_at= null){
    let params = "";
    if(!!created_at){
      params = "?created_at="+created_at;
    }
    return api.get(getNotificationsEndpoint+params);
  },
  readNotifications(){
    return api.get(readNotificationsEndpoint);
  },
  postSendEmails(body){
    return api.post(postSendEmailsEndpoint,body);
  },
  clearNotifications(){
    return api.get(clearNotificationsEndpoint);
  }
}
